import { TabData } from '@/components/ui/Tabs';
import { DOCUMENT_SECTION_TO_TAB_KEY, type DocumentTabKey } from '@/entities/MobileDocumentTabs/config';
import { TabKey } from '@/entities/MobileDocumentTabs/types';
import type { DocumentSectionSlug } from '@/entities/OrganizationSection';

const DOCUMENT_SECTION_ORDER: DocumentSectionSlug[] = ['document-preview', 'ai-summary', 'analyze'];

const TABS_BY_KEY: Record<DocumentTabKey, TabData> = {
  'document-preview': {
    key: 'document-preview',
    value: 'Исходный документ',
  },
  aiSummary: {
    key: 'aiSummary',
    value: 'ИИ-саммари',
  },
  analyze: {
    key: 'analyze',
    value: 'Анализ',
  },
  [TabKey.properties]: {
    key: TabKey.properties,
    value: 'Свойства',
  },
};

type DocumentSectionNames = Partial<Record<DocumentSectionSlug, string>>;

export const getDocumentTabs = (
  enabledSections: DocumentSectionSlug[],
  canEditProperties: boolean,
  sectionNames?: DocumentSectionNames,
): TabData[] => {
  const sectionTabs = DOCUMENT_SECTION_ORDER.filter((sectionSlug) => enabledSections.includes(sectionSlug)).map(
    (sectionSlug) => {
      const tab = TABS_BY_KEY[DOCUMENT_SECTION_TO_TAB_KEY[sectionSlug]];

      return {
        ...tab,
        value: sectionNames?.[sectionSlug] ?? tab.value,
      };
    },
  );

  return canEditProperties ? [...sectionTabs, TABS_BY_KEY[TabKey.properties]] : sectionTabs;
};
